/**
 * 1. Запрос на настройки
 * 2. Если в настройках включена координаты, то запрашиваем координаты, и кладем в store
 * 3. Используем в запросе для получение фоторейтинга.
 */
import { AsyncThunkAction } from 'actions/actions.types'
import { getCoordinatesAction } from 'actions/geolocation/getCoordinatesAction'
import { fetchPhotoRatingSettingsListApi } from 'api/rating/photoRatingSettingsApi'

import {
  FETCH_PHOTO_RATING_SETTINGS,
  fetchPhotoRatingSettingsPlainNotAuthorizedAction,
  savePhotoRatingSettingsPlainAction,
} from './photoRatingSettingsAction'

export const photoRatingSettingNextAction =
  (): AsyncThunkAction => async (dispatch, getState) => {
    const {
      photoRatingSettings: { settingsLoaded },
      authorizationReducer: { authorized },
      systemReducer: { locale: systemLocale },
    } = getState()

    if (!settingsLoaded) {
      if (!authorized) {
        return dispatch(
          fetchPhotoRatingSettingsPlainNotAuthorizedAction(systemLocale)
        )
      }

      return dispatch({
        type: FETCH_PHOTO_RATING_SETTINGS,
        promise: async () => {
          const json = await fetchPhotoRatingSettingsListApi()

          if (json.result?.coordinates) {
            const coordinates = await dispatch(getCoordinatesAction())

            if (!coordinates) {
              await dispatch(
                savePhotoRatingSettingsPlainAction({
                  ageFrom: json.result.ageRange.from,
                  ageTo: json.result.ageRange.to,
                  heightFrom: json.result.heightRange!.from,
                  heightTo: json.result.heightRange!.to,
                  coordinates: false,
                  gender: json.result.gender!,
                  country: json.result.location.country,
                  region: json.result.location.region,
                  city: json.result.location.city,
                  metro: json.result.location.metro,
                  countryName: json.result.locationName.countryName,
                  regionName: json.result.locationName.regionName,
                  cityName: json.result.locationName.cityName,
                  metroName: json.result.locationName.cityName,
                })
              )

              return {
                ...json.result,
                coordinates: false,
              }
            }
          }

          return json
        },
        critical: true,
      })
    }

    return Promise.resolve()
  }
